import React from 'react';
import Button from '@components-clean/core/button';
import { TextArea } from '@components-clean/core/text-area';
import DraggableDialog from 'views-clean/components/core/draggable-dialog';
import { useBoolean } from '@hooks/index';

const DraggableDialogPage = () => {
    const isDialogOpened = useBoolean(false);

    return (
        <>
            <Button onClick={isDialogOpened.toggle} data-testid="toggle-dialog-button" primary>
                Open Dialog
            </Button>
            {isDialogOpened.value && (
                <DraggableDialog
                    height={480}
                    title="Dialog Title"
                    dataTestId="confirmation-dialog"
                    onClose={() => isDialogOpened.setFalse()}
                    onSubmit={() => isDialogOpened.setFalse()}
                    additionalInfoWidth={250}
                    additionalInfoBtnLabel="Info"
                    additionalInfo={
                        <div
                            style={{
                                backgroundColor: '#3e536e08',
                                padding: '12px',
                                border: '1px solid gray',
                            }}
                        >
                            <div className="k-shrink-0 k-d-flex k-justify-content-left k-pb-sm">
                                <div className="!k-basis-1/2 k-font-medium">ObservationId</div>
                                <div className="!k-basis-1/2">123</div>
                            </div>
                            <div className="k-shrink-0 k-d-flex k-justify-content-left k-pb-sm">
                                <div className="!k-basis-1/2 k-font-medium">Type</div>
                                <div className="!k-basis-1/2">type</div>
                            </div>
                            <div className="k-shrink-0 k-d-flex k-justify-content-start k-pb-sm">
                                <div className="!k-basis-1/2 k-font-medium">Status</div>
                                <div className="!k-basis-1/2">status</div>
                            </div>
                            <div className="k-shrink-0 k-d-flex k-justify-content-start k-pb-sm">
                                <div className="k-flex-row !k-basis-1/2 k-font-medium">Site</div>
                                <div className="!k-basis-1/2">Site 123</div>
                            </div>
                            <div className="k-shrink-0 k-d-flex k-justify-content-start k-pb-sm">
                                <div className="!k-basis-1/2 k-font-medium">Dataset Opened</div>
                                <div className="!k-basis-1/2">01-Jan-2000</div>
                            </div>
                            <div className="k-shrink-0 k-d-flex k-justify-content-start k-pb-sm">
                                <div className="k-flex-row !k-basis-1/2 k-font-medium">Observation Date</div>
                                <div className="!k-basis-1/2">01-Jan-2000</div>
                            </div>
                            <div className="k-shrink-0 k-d-flex k-justify-content-left k-pb-sm">
                                <div className="!k-basis-1/2 k-font-medium">Association</div>
                                <div className="!k-basis-1/2">association</div>
                            </div>
                            <div className="k-shrink-0 k-d-flex k-justify-content-left k-pb-sm">
                                <div className="!k-basis-1/2 k-font-medium">Decision</div>
                                <div className="!k-basis-1/2">decision</div>
                            </div>
                            <div className="k-shrink-0 k-justify-content-left k-d-flex-col k-pb-sm">
                                <div className="k-font-medium">Root Cause</div>
                                <div className="">
                                    <TextArea
                                        style={{
                                            height: '60px',
                                            overflowY: 'auto',
                                            overflowX: 'hidden',
                                        }}
                                        name="rootCause"
                                        data-testid="field-select-rootCause"
                                        fillMode="solid"
                                        readOnly
                                        value="This is a default value for the root cause, This is a default value for the root
                                    cause, This is a default value for the root cause, This is a default value for the
                                    root cause"
                                    />
                                </div>
                            </div>
                            <div className="k-shrink-0 k-justify-content-left k-d-flex-col k-pb-sm">
                                <div className="k-font-medium">Comments</div>
                                <div className="k-overflow-y-auto">
                                    <TextArea
                                        style={{
                                            height: '60px',
                                            overflowY: 'auto',
                                            overflowX: 'hidden',
                                        }}
                                        name="rootCause"
                                        data-testid="field-select-rootCause"
                                        fillMode="solid"
                                        readOnly
                                        value="This is a default value for the root cause, This is a default value for the root
                                    cause, This is a default value for the root cause, This is a default value for the
                                    root cause"
                                    />
                                </div>
                            </div>
                        </div>
                    }
                >
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit
                </DraggableDialog>
            )}
        </>
    );
};

export default DraggableDialogPage;
